import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CalendarOutlined,
  HeartOutlined,
  ArrowRightOutlined,
  SafetyOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  SunOutlined,
  MoonOutlined,
} from "@ant-design/icons";
import "../PortalLanding.css"; // import external styles

/* Animated counter */
function useCount(target, duration = 1200) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      setVal(Math.floor(progress * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration]);
  return val;
}

/* Main component */
function PortalLanding() {
  const navigate = useNavigate();
  const doctors = useCount(48, 1400);

  // Theme state (default dark)
  const [isDark, setIsDark] = useState(true);
  const toggleTheme = () => setIsDark(prev => !prev);

  return (
    <div className={`pl-root ${isDark ? 'dark' : 'light'}`}>

      {/* Theme toggle button */}
      <button className="pl-theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
        {isDark ? <SunOutlined /> : <MoonOutlined />}
      </button>

      {/* Hero banner */}
      <div className="pl-hero pl-rise pl-rise-1">
        <div className="pl-hero-card">
          <div className="pl-hero-grid" />

          {/* Hero text */}
          <div className="pl-hero-text">
            <div className="pl-hero-eyebrow">Atlantispediatric</div>
            <h1 className="pl-hero-title">
              Hospital Portal<br />
              <em>powered by HealthWyse</em>
            </h1>
          </div>
        </div>
      </div>

      {/* Prompt */}
      <p className="pl-prompt pl-rise pl-rise-2 text-2">
        Please select a portal to sign in
      </p>

      {/* Channel cards */}
      <div className="pl-channels">

        {/* Appointment portal */}
        <div
          className="pl-channel-card pl-card-appt pl-rise pl-rise-3"
          onClick={() => navigate("/login")}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === "Enter" && navigate("/login")}
        >
          <div className="pl-card-icon pl-icon-appt">
            <CalendarOutlined />
          </div>
          <div className="pl-card-text">
            <div className="pl-card-title">Appointment Portal</div>
            <div className="pl-card-sub">
              For new &amp; registered patient <br />
              Book appointments
            </div>
          </div>
          <div className="pl-card-arrow">
            <ArrowRightOutlined />
          </div>
        </div>

        {/* Patient portal */}
        <div
          className="pl-channel-card pl-card-patient pl-rise pl-rise-4"
          onClick={() => navigate("/portal-login")}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === "Enter" && navigate("/portal-login")}
        >
          <div className="pl-card-icon pl-icon-patient">
            <HeartOutlined />
          </div>
          <div className="pl-card-text">
            <div className="pl-card-title">Patient Portal</div>
            <div className="pl-card-sub">
              For registered patients<br />
              View visits &amp; health records
            </div>
          </div>
          <div className="pl-card-arrow">
            <ArrowRightOutlined />
          </div>
        </div>

      </div>

      {/* Feature chips */}
      <div className="pl-features pl-rise pl-rise-5">
        <div className="pl-feat-chip">
          <SafetyOutlined /> HIPAA Compliant
        </div>
        <div className="pl-feat-chip">
          <ClockCircleOutlined /> 24/7 Available
        </div>
        <div className="pl-feat-chip">
          <TeamOutlined /> {doctors}+ Specialists
        </div>
      </div>

      {/* Footer */}
      <div className="pl-footer">
        © {new Date().getFullYear()} Bravo Health Limited. All rights reserved. · v1.0
      </div>

    </div>
  );
}

export default PortalLanding;